export default "__VITE_ASSET__c1d3eeb8__"